import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import RepTest from "./pages/RepTest";
import Admin from "./pages/Admin";
import Terms from "./pages/Terms";

function App() {
  return (
    <div className="App">
      <div className="noise" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RepTest />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { borderRadius: 0, fontFamily: "JetBrains Mono" } }} />
    </div>
  );
}

export default App;
